import _ from "lodash";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getGuestProfile, saveGuestProfile } from "../actions/init";
import { getExtProfileInfo, valaquenta_api_url } from "../api";
import { brand, custom_auth, ext_crm, source_entity } from "../context";
import { isElligibleToBookSelector, isElligibleToSearchSelector } from "../selectors";

export function useProfileState() {
  const { guestProfile } = useSelector((state: { GuestProfile: any }) => {
    const guestProfile = state.GuestProfile;
    return { guestProfile };
  });
  const profile = custom_auth ? (guestProfile?.extProfile ?? {}) : guestProfile;
  return { profile };
}

export const ProfileHoc = (WrappedComponent: any, withAuth: boolean = true) => {
  const ProfileHocComp = (props: any) => {
    const history = useHistory();
    const [guestProfileLoading, setGuestProfileLoading] = useState(withAuth);
    const {
      guestProfile = { guest: "guest" },
      user_id = "",
      saveExternalGuest,
      userIsElligibleToAccess = true,
      userIsElligibleToBook = true,
    } = props;
    var { getGuest } = props;

    const website_api_key = useSelector(
      (state: { WebsiteMetadata: any }) => state?.WebsiteMetadata?.metadata?.api_key,
    );

    // Get guest information from our GuestCRM
    useEffect(() => {
      if (custom_auth) return;
      if (ext_crm) return;
      if (!user_id) return;
      if (!_.isEmpty(guestProfile)) return;

      setGuestProfileLoading(true);
      getGuest(user_id).then(() => setGuestProfileLoading(false));
    }, [user_id]);

    // ================ EXTERNAL CUSTOM AUTHENTICATION ===============
    async function extProfileGetter({
      payload,
      source_entity,
      website_api_key,
    }: {
      payload: any;
      source_entity: string;
      website_api_key: string;
    }) {
      const { token } = payload;

      const result = await getExtProfileInfo({
        token,
        source_entity,
        website_api_key,
      });

      if (!result || _.isEmpty(result)) {
        setGuestProfileLoading(false);
        return;
      }

      const extProfile = {
        ...result,
        external_custom: true,
        provider: brand,
        endpoint: valaquenta_api_url,
      };

      saveExternalGuest({ extProfile });
      window.localStorage.setItem("extProfile", JSON.stringify(extProfile));
      setGuestProfileLoading(false);
    }

    // Get guest profile from our guestcrm
    useEffect(() => {
      if (!custom_auth) return;
      if (!history || !website_api_key) {
        setGuestProfileLoading(false);
        return;
      }

      const routerSearch = history.location.search;
      const params = new URLSearchParams(routerSearch);
      const token = params.get("token");
      if (!token) {
        setGuestProfileLoading(false);
        return;
      }

      var payload = { token };
      setGuestProfileLoading(true);
      extProfileGetter({ payload, source_entity, website_api_key });
    }, [website_api_key]);

    return (
      <WrappedComponent
        {...props}
        userIsElligibleToAccess={userIsElligibleToAccess}
        userIsElligibleToBook={userIsElligibleToBook}
        guestProfileLoading={guestProfileLoading}
      />
    );
  };
  ProfileHocComp.propTypes = {
    history: PropTypes.object,
    token: PropTypes.string,
    guestProfile: PropTypes.object.isRequired,
    user_id: PropTypes.string,
    userIsElligibleToAccess: PropTypes.bool.isRequired,
    userIsElligibleToBook: PropTypes.bool.isRequired,
    bookMsg: PropTypes.string,
    getGuest: PropTypes.func.isRequired,
    saveExternalGuest: PropTypes.func.isRequired,
  };
  const mapStateToProps = (state: any) => {
    const userIsElligibleToAccess = withAuth ? isElligibleToSearchSelector(state) : true;

    const userIsElligibleToBook = isElligibleToBookSelector(state);

    return {
      guestProfile: state.GuestProfile,
      userIsElligibleToAccess,
      userIsElligibleToBook: withAuth ? userIsElligibleToBook : true,
    };
  };
  const mapDispatchToProps = (dispatch: Function) => {
    return {
      getGuest: (user_id: string) => dispatch(getGuestProfile(user_id)),
      saveExternalGuest: (guestProfile: any) => dispatch(saveGuestProfile(guestProfile)),
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(ProfileHocComp);
};
